"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PTHome = (0, _asyncComponent2.default)(function () {
    return import("../Screens/PTHome").then(function (module) {
        return module.default;
    });
});
var AssessPay = (0, _asyncComponent2.default)(function () {
    return import("../Screens/AssessPay").then(function (module) {
        return module.default;
    });
});
var SearchProperty = (0, _asyncComponent2.default)(function () {
    return import("../Screens/SearchProperty").then(function (module) {
        return module.default;
    });
});
var CompletedAssessments = (0, _asyncComponent2.default)(function () {
    return import("../Screens/CompletedAssessments").then(function (module) {
        return module.default;
    });
});
var IncompleteAssessments = (0, _asyncComponent2.default)(function () {
    return import("../Screens/IncompleteAssessments").then(function (module) {
        return module.default;
    });
});
var MyProperties = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MyProperties").then(function (module) {
        return module.default;
    });
});
var Property = (0, _asyncComponent2.default)(function () {
    return import("egov-ui-kit/common/propertyTax/Property").then(function (module) {
        return module.default;
    });
});
var ApplicationPreview = (0, _asyncComponent2.default)(function () {
    return import("egov-ui-kit/common/propertyTax/ApplicationPreview").then(function (module) {
        return module.default;
    });
});
var SafPreview = (0, _asyncComponent2.default)(function () {
    return import("egov-ui-kit/common/propertyTax/SafPreview").then(function (module) {
        return module.default;
    });
});

var MyReceipts = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MyReceipts").then(function (module) {
        return module.default;
    });
});

var PaymentSuccess = (0, _asyncComponent2.default)(function () {
    return import("../Screens/PaymentSuccess").then(function (module) {
        return module.default;
    });
});
var PaymentFailure = (0, _asyncComponent2.default)(function () {
    return import("../Screens/PaymentFailure").then(function (module) {
        return module.default;
    });
});
var ReviewForm = (0, _asyncComponent2.default)(function () {
    return import("../Screens/ReviewForm").then(function (module) {
        return module.default;
    });
});
var PastPayment = (0, _asyncComponent2.default)(function () {
    return import("../Screens/LinkPastPayments").then(function (module) {
        return module.default;
    });
});
var PaymentRedirectPage = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Payment-rediect-page").then(function (module) {
        return module.default;
    });
});
var HowItWorks = (0, _asyncComponent2.default)(function () {
    return import("egov-ui-kit/common/propertyTax/HowItWorks").then(function (module) {
        return module.default;
    });
});
var PTExamples = (0, _asyncComponent2.default)(function () {
    return import("egov-ui-kit/common/propertyTax/PTExample").then(function (module) {
        return module.default;
    });
});
var FormWizard = (0, _asyncComponent2.default)(function () {
    return import("../Screens/FormWizard").then(function (module) {
        return module.default;
    });
});

var ptAcknowledgment = (0, _asyncComponent2.default)(function () {
    return import("egov-ui-kit/common/propertyTax/PTAcknowledgement").then(function (module) {
        return module.default;
    });
});

// mutation details
var MutationDetails = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MutationScreen").then(function (module) {
        return module.default;
    });
});

var MutationStatusSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MutationScreen/mutationStatusSearch").then(function (module) {
        return module.default;
    });
});

var SearchAssessee = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MutationScreen/searchAssessee").then(function (module) {
        return module.default;
    });
});
//upload documents
var UploadDocuments = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MutationScreen/uploadDocuments").then(function (module) {
        return module.default;
    });
});

var ResponseCapture = (0, _asyncComponent2.default)(function () {
    return import("../Screens/ResponseCapture").then(function (module) {
        return module.default;
    });
});
var PropertySearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/PropertySearch").then(function (module) {
        return module.default;
    });
});
var CurrentDemands = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Demand/CurrentDemandList").then(function (module) {
        return module.default;
    });
});
var PaymentTranscation = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Demand/PaymentTranscation").then(function (module) {
        return module.default;
    });
});
var ApplySearchSaf = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Saf/ApplySafSearch").then(function (module) {
        return module.default;
    });
});

var SafSummary = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Saf/ApplySaf/Forms/SafSummary").then(function (module) {
        return module.default;
    });
});
var ViewUpdateSaf = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Saf/FetchViewSaf").then(function (module) {
        return module.default;
    });
});

var ApplySaf = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Saf/ApplySaf").then(function (module) {
        return module.default;
    });
});

var ResponseCaptureSaf = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Saf/ResponseCapture").then(function (module) {
        return module.default;
    });
});

//check payments status
var CheckPaymentStatus = (0, _asyncComponent2.default)(function () {
    return import("../Screens/PaymentStatus").then(function (module) {
        return module.default;
    });
});

//Print unpaid Bill
var PrintUnpaidBill = (0, _asyncComponent2.default)(function () {
    return import("../Screens/PrintUnpaidBill").then(function (module) {
        return module.default;
    });
});

//Print E-receipts
var EReceipts = (0, _asyncComponent2.default)(function () {
    return import("../Screens/EReceipts").then(function (module) {
        return module.default;
    });
});

//Print AssessmentReport
var AssessmentReport = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Assessment Report/ArReport").then(function (module) {
        return module.default;
    });
});

//AssesseeInformationSearch
var AssesseeInformationSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/AssesseeInformation").then(function (module) {
        return module.default;
    });
});

//Hearing Notice Search
var HearingNoticeSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/HearingNotice").then(function (module) {
        return module.default;
    });
});

//suspensePayment/Miscellaneous Payment crete
var suspensePayment = (0, _asyncComponent2.default)(function () {
    return import("../Screens/SuspensePayment").then(function (module) {
        return module.default;
    });
});

var MayorWaiverFiftyPercentPayment = (0, _asyncComponent2.default)(function () {
    return import("../Screens/MakeOnlinePayments/mayorWavierPayments").then(function (module) {
        return module.default;
    });
});

//OccupancySearch
var OccupancySearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/OccupancyA75/occupancySearch").then(function (module) {
        return module.default;
    });
});

//OccupancyForm
var OccupancyForm = (0, _asyncComponent2.default)(function () {
    return import("../Screens/OccupancyA75/occupancyForm").then(function (module) {
        return module.default;
    });
});

//InterestWaiveSearch
var InterestWaiveSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/50% Interest Waive/search").then(function (module) {
        return module.default;
    });
});
var FormObjection = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Saf/FormObjection").then(function (module) {
        return module.default;
    });
});

//InterestWaiveApplicationForm
var InterestWaiveApplicationForm = (0, _asyncComponent2.default)(function () {
    return import("../Screens/50% Interest Waive/interestWaiveApplication").then(function (module) {
        return module.default;
    });
});

//AdjustmentAgainstLoi
var AdjustmentAgainstLoi = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Adjustment/adjustmentAgainst99Percent").then(function (module) {
        return module.default;
    });
});
//AdjustmentAgainstPD
var AdjustmentAgainstPD = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Adjustment/adjustmentagainst5Percent").then(function (module) {
        return module.default;
    });
});
//NormalAdjustment
var NormalAdjustment = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Adjustment/normalAdjustment").then(function (module) {
        return module.default;
    });
});

//SuspenseAdjustmentsReport
var SuspenseAdjustmentsReport = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Adjustment/suspenseAdjustmentsReport").then(function (module) {
        return module.default;
    });
});

//assesseeAddressChangeSearch
var assesseeAddressChangeSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Address Change/assesseeAddressChangeSearch").then(function (module) {
        return module.default;
    });
});

//Assessee Address Change Apply Form route
var addressChangeFormAndView = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Address Change/addressChangeFormAndView").then(function (module) {
        return module.default;
    });
});
//assesseeAddressChangeSearch
var assesseeAddressChangeStatusSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Address Change/assesseeAddressChangeStatusSearch").then(function (module) {
        return module.default;
    });
});

var DocumentsUploadForAddressChange = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Address Change/DocumentsUpload").then(function (module) {
        return module.default;
    });
});

// MIsc payment
var miscPayment = (0, _asyncComponent2.default)(function () {
    return import("../Screens/Payments/MISCPayment").then(function (module) {
        return module.default;
    });
});

//noc Download route
var DownloadNoc = (0, _asyncComponent2.default)(function () {
    return import("../Screens/NocScreens/DownloadNoc").then(function (module) {
        return module.default;
    });
});

//IB COPY
var IBcopyAssesseeSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/IB COPY/search").then(function (module) {
        return module.default;
    });
});

var IbCopyCreate = (0, _asyncComponent2.default)(function () {
    return import("../Screens/IB COPY/create").then(function (module) {
        return module.default;
    });
});

var IBcopyCaseSearch = (0, _asyncComponent2.default)(function () {
    return import("../Screens/IB COPY/StatusSearch").then(function (module) {
        return module.default;
    });
});

var SlabWiseWaiverCalculation = (0, _asyncComponent2.default)(function () {
    return import("../Screens/SlabWiseWaiver/index").then(function (module) {
        return module.default;
    });
});
var HawkerPayment = (0, _asyncComponent2.default)(function () {
    return import("../Screens/HawkerPayment/index").then(function (module) {
        return module.default;
    });
});
var HawkerPaymentReceipt = (0, _asyncComponent2.default)(function () {
    return import("../Screens/HawkerPayment/receipt").then(function (module) {
        return module.default;
    });
});

var ThikaEntryScreen = (0, _asyncComponent2.default)(function () {
    return import("../Screens/ThikaWorker/thickaEntry").then(function (module) {
        return module.default;
    });
});
var SearchThika = (0, _asyncComponent2.default)(function () {
    return import("../Screens/ThikaWorker/thickSearch").then(function (module) {
        return module.default;
    });
});

var routes = [{
    path: "property-tax/hawker-payment",
    component: HawkerPayment,
    needsAuthentication: true
}, {
    path: "property-tax/hawker-payment-receipt",
    component: HawkerPaymentReceipt,
    needsAuthentication: true
}, {
    path: "property-tax/saf/search-apply-saf",
    component: ApplySearchSaf,
    needsAuthentication: true
}, {
    path: "property-tax/payment/misc-payment",
    component: miscPayment,
    needsAuthentication: true
}, {
    path: "property-tax/saf/saf-summary",
    component: SafSummary,
    needsAuthentication: true
}, {
    path: "property-tax/saf/fetchViewSaf",
    component: ViewUpdateSaf,
    needsAuthentication: true
}, {
    path: "property-tax/saf/responseCapture",
    component: ResponseCaptureSaf,
    needsAuthentication: true
}, {
    path: "property-tax/saf/formObjection",
    component: FormObjection,
    needsAuthentication: true
}, {
    path: "property-tax/saf/apply-saf",
    component: ApplySaf,
    needsAuthentication: true
}, {
    path: "property-tax",
    component: PTHome,
    needsAuthentication: true
}, {
    path: "property-tax/assess-pay",
    component: AssessPay,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        title: "PT_ASSESPAY_SELECTPROPERTY"
    }
}, {
    path: "property-tax/incomplete-assessments",
    component: IncompleteAssessments,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        title: "PT_INCOMPLETE_ASSESSMENT"
    }
}, {
    path: "property-tax/completed-assessments",
    component: CompletedAssessments,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        title: "PT_COMPLETED_ASSESSMENTS"
    }
}, {
    path: "property-tax/my-properties",
    component: MyProperties,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideTitle: true,
        title: "PT_HOME_MYPROPERTIES"
    }
}, {
    path: "property-tax/my-properties/property/:propertyId/:tenantId",
    component: Property,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideTitle: true
    }
}, {
    path: "property-tax/property-search",
    component: PropertySearch,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideTitle: true
    }
}, {
    path: "property-tax/application-preview",
    component: ApplicationPreview,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideTitle: true
    }
}, {
    path: "property-tax/saf-preview",
    component: SafPreview,
    needsAuthentication: true,
    options: {
        // hideTitle:true,
        hideFooter: true,
        hideTitle: true
    }
}, {
    path: "property-tax/my-properties/reassess-property/:propertyId/:tenantId",
    component: Property,
    needsAuthentication: true,
    options: {
        hideTitle: true,
        hideFooter: true
    }
}, {
    path: "property-tax/response-capture",
    component: ResponseCapture,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/assess-pay/search-property",
    component: SearchProperty,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        title: "PT_PROPERTY_TAX",
        hideTitle: true,
        helpButton: true
    }
}, {
    path: "property-tax/my-receipts",
    component: MyReceipts,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        title: "My Receipts",
        hideBackButton: true
    }
}, {
    path: "property-tax/payment-success/:propertyId/:tenantId",
    component: PaymentSuccess,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideBackButton: true,
        hideTitle: true
    }
}, {
    path: "property-tax/payment-failure/:propertyId/:tenantId/:assessmentNumber/:assessmentYear/:txnAmount",
    component: PaymentFailure,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideBackButton: true,
        hideTitle: true
    }
}, {
    path: "propert-tax/review-property",
    component: ReviewForm,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideBackButton: true
    }
}, {
    path: "property-tax/past-payment",
    component: PastPayment,
    needsAuthentication: true
}, {
    path: "property-tax/payment-redirect-page",
    component: PaymentRedirectPage,
    needsAuthentication: true,
    options: {
        hideFooter: true,
        hideBackButton: true,
        hideTitle: true
    }
}, {
    path: "property-tax/how-it-works",
    component: HowItWorks,
    needsAuthentication: true,
    options: {
        hideFooter: true,

        title: "PT_HOW_IT_WORKS"
    }
}, {
    path: "property-tax/pt-examples",
    component: PTExamples,
    needsAuthentication: true,
    options: {
        hideFooter: true,

        title: "PT_EXAMPLES"
    }
}, {
    path: "property-tax/pt-acknowledgment",
    component: ptAcknowledgment,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true

        // title: "PT_ACKNOWLEDGEMENT"
    }
}, {
    path: "property-tax/mutation-details",
    component: MutationDetails,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/mutation-search-assessee",
    component: SearchAssessee,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/Emutation-status-search",
    component: MutationStatusSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/upload-documents",
    component: UploadDocuments,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/current-demand",
    component: CurrentDemands,
    needsAuthentication: true,
    options: { hideFooter: false, hideTitle: true }
}, {
    // property-tax/demand/transactions
    path: "property-tax/demand/transcations",
    component: PaymentTranscation,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/payments-status",
    component: CheckPaymentStatus,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/unpaid-bill-print",
    component: PrintUnpaidBill,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/print-ereceipts",
    component: EReceipts,
    needsAuthentication: true,
    options: { hideFooter: false, hideTitle: true }
},
//AssessmentReport /AR Copy report
{
    path: "property-tax/assessment-report-print",
    component: AssessmentReport,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//AssesseeInformationSearch
{
    path: "property-tax/AssesseeInformationSearch",
    component: AssesseeInformationSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/hearing-notice-search",
    component: HearingNoticeSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//   make online Payments for suspensePayment
{
    path: "property-tax/suspense-payment",
    component: suspensePayment,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//   make online Payments for 50% mayor waiver payment
{
    path: "property-tax/mayor-waiver-fifty-percent-payment",
    component: MayorWaiverFiftyPercentPayment,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//Occupancy search route
{
    path: "property-tax/occupancy-in-out-search",
    component: OccupancySearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//Occupancy form route
{
    path: "property-tax/occupancy-in-out-form",
    component: OccupancyForm,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//InterestWaiveSearch route
{
    path: "property-tax/interest-waiver-search",
    component: InterestWaiveSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//InterestWaiveApplicationForm route
{
    path: "property-tax/interest-waiver-application-form",
    component: InterestWaiveApplicationForm,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/suspense/extra-five-adjustment-against-pd",
    component: AdjustmentAgainstPD,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//ninety-nine-adjustment-against-pd route
{
    path: "property-tax/suspense/ninety-nine-adjustment-against-loi",
    component: AdjustmentAgainstLoi,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//NormalAdjustment route
{
    path: "property-tax/suspense/simple-adjustment",
    component: NormalAdjustment,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//SuspenseAdjustmentsReport route
{
    path: "property-tax/suspense/adjustments-report",
    component: SuspenseAdjustmentsReport,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//Assessee Address Change Search route
{
    path: "property-tax/address-change/assessee-search",
    component: assesseeAddressChangeSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//Assessee Address Change Apply Form route
{
    path: "property-tax/address-change/view-form",
    component: addressChangeFormAndView,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},
//Assessee Address Change Status Search route
{
    path: "property-tax/address-change/status-search",
    component: assesseeAddressChangeStatusSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/assessee/address-change/documents-upload",
    component: DocumentsUploadForAddressChange,
    needsAuthentication: true
},

//Noc Download screen
{
    path: "property-tax/noc-report",
    component: DownloadNoc,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
},

//IB COPY  URL
{
    path: "property-tax/demand/assessee-search-for-ib-copy",
    component: IBcopyAssesseeSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/demand/create-ib-copy",
    component: IbCopyCreate,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/demand/ib-copy-case-search/status",
    component: IBcopyCaseSearch,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/waiver/slab-wise-calculation",
    component: SlabWiseWaiverCalculation,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/thika/entry-form",
    component: ThikaEntryScreen,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}, {
    path: "property-tax/thika/search-form",
    component: SearchThika,
    needsAuthentication: true,
    options: {
        hideFooter: false,
        hideTitle: true
    }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/pt-citizen/Routes/pt-routes.js
// module id = 3514
// module chunks = 1137